<template>
    <b-row>
        <b-col cols="12">
            <div class="d-flex align-items-center">
                <div class="ml-auto">
                    <div
                        class="d-sm-flex mb-4 justify-content-end align-items-center"
                    >
                        <b-button
                            variant="primary"
                            size="md"
                            class="d-flex align-items-center mt-4 mt-sm-0 mr-4"
                            @click="addRegister"
                            v-b-popover.hover.top="'Presione alt+a o option+a'"
                            :disabled="
                                !permisos.includes('devolucion-factura-crear')
                            "
                        >
                            <feather
                                type="plus"
                                size="1rem"
                                class="mr-2 blue-active-text"
                            ></feather>
                            Nueva devolución
                        </b-button>
                        <b-dropdown
                            id="dropdown-divider"
                            text="Opciones"
                            size="md"
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            :disabled="
                                !permisos.includes(
                                    'devolucion-factura-query-export'
                                ) &&
                                !permisos.includes(
                                    'devolucion-factura-query-export-and-email'
                                ) &&
                                !permisos.includes(
                                    'devolucion-factura-crud-export'
                                ) &&
                                !permisos.includes(
                                    'devolucion-factura-crud-import'
                                )
                            "
                        >
                            <template #button-content>
                                <div
                                    class="d-flex justify-content-center align-items-center"
                                >
                                    <feather
                                        type="more-horizontal"
                                        size="1.5rem"
                                        class="text-secondary"
                                    ></feather>
                                </div>
                            </template>
                            <b-dropdown-item-button
                                v-for="(format, index) in formats"
                                :key="index"
                                @click="verifyFields(format.ext)"
                                :disabled="
                                    !permisos.includes(
                                        'devolucion-factura-query-export'
                                    )
                                "
                            >
                                {{ format.name }}
                            </b-dropdown-item-button>
                            <b-dropdown-item-button
                                @click="$bvModal.show('email-modal')"
                                :disabled="
                                    !permisos.includes(
                                        'devolucion-factura-query-export-and-email'
                                    )
                                "
                                >Enviar informe por
                                Correo</b-dropdown-item-button
                            >
                            <!--
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item-button
                                    @click="getImportFormat(moduleName)"
                                    :disabled="
                                        !permisos.includes('devolucion-factura-crud-export')
                                    "
                                    >Plantilla para importación de
                                    tabla</b-dropdown-item-button
                                >
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item-button
                                    @click="$refs.excelInput.click()"
                                    :disabled="
                                        !permisos.includes('devolucion-factura-crud-import')
                                    "
                                    >Cargar Plantilla para importación de
                                    tabla</b-dropdown-item-button
                                > -->
                        </b-dropdown>
                    </div>
                </div>
            </div>
        </b-col>
        <b-col cols="12" lg="12" class="d-flex align-items-stretch">
            <b-card class="mb-4 w-100 h-100">
                <div class="mt-5">
                    <b-form v-hotkey="keymap">
                        <b-row class="mt-5">
                            <b-col cols="12" sm="4">
                                <b-form-group>
                                    <label for="fecha_inicio"
                                        >Fecha Inicio</label
                                    >
                                    <b-input-group>
                                        <b-form-input
                                            id="fecha_inicio"
                                            v-model="
                                                $v.form.fecha_inicio.$model
                                            "
                                            type="text"
                                            placeholder="AAAA-MM-DD"
                                            :state="
                                                validateState('fecha_inicio')
                                            "
                                            autocomplete="null"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-form-datepicker
                                                v-model="
                                                    $v.form.fecha_inicio.$model
                                                "
                                                button-only
                                                right
                                                locale="en-US"
                                                :state="
                                                    validateState(
                                                        'fecha_inicio'
                                                    )
                                                "
                                                aria-controls="fecha_inicio"
                                            ></b-form-datepicker>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback
                                        :state="$v.form.fecha_inicio.formatDate"
                                    >
                                        Formato de fecha inválido
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        :state="
                                            $v.form.fecha_inicio.compareDates
                                        "
                                    >
                                        La fecha inicial no puede ser mayor a la
                                        fecha final
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>

                            <b-col cols="12" md="4">
                                <b-form-group>
                                    <label for="fecha_inicio"
                                        >Fecha Final</label
                                    >
                                    <b-input-group>
                                        <b-form-input
                                            id="fecha_final"
                                            v-model="$v.form.fecha_final.$model"
                                            type="text"
                                            placeholder="AAAA-MM-DD"
                                            :state="
                                                validateState('fecha_final')
                                            "
                                            autocomplete="null"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-form-datepicker
                                                v-model="
                                                    $v.form.fecha_final.$model
                                                "
                                                button-only
                                                right
                                                locale="en-US"
                                                :state="
                                                    validateState('fecha_final')
                                                "
                                                aria-controls="fecha_final"
                                            ></b-form-datepicker>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <b-form-invalid-feedback
                                        :state="$v.form.fecha_final.formatDate"
                                    >
                                        Formato de fecha inválido
                                    </b-form-invalid-feedback>
                                    <b-form-invalid-feedback
                                        :state="
                                            $v.form.fecha_final.compareDates
                                        "
                                    >
                                        La fecha inicial no puede ser mayor a la
                                        fecha final
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" sm="4">
                                <label for="prefijo">Prefijo</label>
                                <jautocomplete
                                    id="prefijo"
                                    :items="consecutivos"
                                    item-value="prefijo"
                                    item-text="prefijo"
                                    open-on-focus
                                    v-model="$v.form.prefijo_id.$model"
                                >
                                    <!-- :custom-filter="filterConsecutivos"
                                    :custom-text-field="textFieldPrefijo" -->
                                    <!-- optional-item-text="descripcion" -->
                                    <!-- <template v-slot:option="{ item }">
                                        <span>
                                            {{
                                                item.prefijo || item.descripcion
                                            }}</span
                                        >
                                    </template> -->
                                </jautocomplete>
                                <!-- return-object
                                    @change="
                                        ($evt) =>
                                            ($v.form.prefijo_id.$model =
                                                $evt.prefijo)
                                    " -->
                                <!-- v-model="$v.form.prefijo_id.$model" -->
                                <!-- :state="validateState('prefijo_id')" -->
                            </b-col>
                        </b-row>
                        <b-row class="mt-4">
                            <b-col cols="12">
                                <b-form-group>
                                    <label for="filter-input"
                                        >Texto adicional para buscar</label
                                    >
                                    <b-form-input
                                        id="filter-input"
                                        type="text"
                                        placeholder="Escriba algún texto para buscar"
                                        v-model="search"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <div class="float-right mb-5">
                            <b-button
                                variant="primary"
                                size="md"
                                class="mt-4 d-flex align-items-center"
                                v-b-popover.hover.top="
                                    'Presione ctrl+b o cmd+b'
                                "
                                @click="getDevolucionesFacturas()"
                            >
                                <feather
                                    type="search"
                                    size="1rem"
                                    class="text-blue-active mr-2"
                                ></feather>
                                <span>Consultar</span>
                            </b-button>
                        </div>
                    </b-form>
                </div>
                <div class="table-responsive mt-3">
                    <b-table
                        :fields="fields"
                        :items="devoluciones_factura"
                        :tbody-tr-class="rowClass"
                        borderless
                        responsive
                        head-variant="light"
                        class="mb-0 hover-table text-nowrap"
                    >
                        <template #cell(prefijo)="data">
                            <span
                                :class="`badge bg-light-success ${
                                    Theme === 'dark' && 'text-gray'
                                }`"
                            >
                                <feather
                                    type="hash"
                                    size="0.8rem"
                                    class="mr-1"
                                />
                                {{ data.item.consecutivo.prefijo || 'Sin prefijo'}}{{ data.item.numero }}
                            </span>
                        </template>

                        <template #cell(notaCreditoE)="data">
                            <span :class="`text-${getStatusColor(data.value.estadoDocumento?.codigo)}`">
                                {{ Object.keys(data.value).length > 0 ? data.value.estadoDocumento?.codigo || 'SIN ESTADO' : 'NO' }}
                            </span>
                        </template>

                        <template #cell(numero_factura)="data">
                            <span :class="`text-${!data.value && 'secondary'}`">
                                {{ data.value ? `${data.item.consecutivo_factura.prefijo}${data.value}` : 'SIN DOCUMENTO' }}
                            </span>
                        </template>

                         <template #cell(cliente)="data">
                            <span>
                                {{ data.value.codigo }} - {{ data.value.nombre_comercial }}
                            </span>
                        </template>
                        <template #cell(cliente_id)="data">
                            <span>
                                {{ data.item.cliente.tercero.n_documento }} - {{ getLabelTercero(data.item.cliente.tercero) }}
                            </span>
                        </template>
                        <template #cell(gran_total)="data">
                            <span>
                                {{ currencyFormat(data.value.toFixed(2)) }}
                            </span>
                        </template>
                        <template #cell(acciones)="data">
                            <feather
                                type="eye"
                                role="button"
                                @click="
                                    $router.push({
                                        name: 'Ver devolucion de factura',
                                        params: {
                                            devolucion_id: data.item.id
                                        }
                                    })
                                "
                                v-b-popover.hover.top="'Ver'"
                            ></feather>

                            <span v-if="!isLoading">
                                <feather
                                    v-if="
                                        (data.item.notaCreditoE.estadoDocumento !==
                                            undefined &&
                                            (data.item.notaCreditoE.estadoDocumento
                                                .codigo === 'DEFAULT' ||
                                                data.item.notaCreditoE
                                                    .estadoDocumento.codigo ===
                                                    'RECHAZADO')) ||
                                        data.item.notaCreditoE.reenviar
                                    "
                                    type="refresh-cw"
                                    role="button"
                                    class="ml-2"
                                    @click="
                                        confirmResendNc({
                                            id: data.item.id,
                                            numero: `${data.item.consecutivo.prefijo}${data.item.numero}`
                                        })
                                    "
                                    v-b-popover.hover.top="
                                        'Reenviar devolución electrónica'
                                    "
                                ></feather>
                            </span>

                            <span v-else>
                                <feather
                                    v-if="(data.item.notaCreditoE.estadoDocumento !==
                                            undefined &&
                                            (data.item.notaCreditoE.estadoDocumento
                                                .codigo === 'DEFAULT' ||
                                                data.item.notaCreditoE
                                                    .estadoDocumento.codigo ===
                                                'RECHAZADO')) ||
                                        data.item.notaCreditoE.reenviar
                                        "
                                    type="refresh-cw"
                                    role="button"
                                    class="ml-2 text-secondary"
                                    v-b-popover.hover.top="'Reenviar devolución electrónica'"
                                ></feather>
                            </span>


                            <feather
                                v-if="
                                    permisos.includes(
                                        'devolucion-factura-export-individual-and-email'
                                    ) && !isLoading && !((data.item.notaCreditoE.estadoDocumento !==
                                    undefined &&
                                    (data.item.notaCreditoE.estadoDocumento
                                        .codigo === 'DEFAULT' ||
                                        data.item.notaCreditoE
                                            .estadoDocumento.codigo ===
                                        'RECHAZADO')) ||
                                    data.item.notaCreditoE.reenviar)
                                "
                                type="mail"
                                role="button"
                                class="ml-2"
                                v-b-popover.hover.top="'Enviar por correo'"
                                @click="sendSingleFactura(data.item.id)"
                            ></feather>

                            <feather
                                v-else
                                type="mail"
                                role="button"
                                class="ml-2 text-secondary"
                                v-b-popover.hover.top="'Enviar por correo'"
                            ></feather>

                            <!-- <feather
                                v-if="
                                    data.item.notaCreditoE !== undefined &&
                                    (data.item.notaCreditoE.codigo ===
                                        'DEFAULT' ||
                                        data.item.notaCreditoE.codigo ===
                                            'RECHAZADO')
                                "
                                type="refresh-cw"
                                role="button"
                                class="ml-2"
                                v-b-popover.hover.top="
                                    'Reenviar factura electrónica'
                                "
                                @click="
                                    confirmResendNc({
                                        id: data.item.id,
                                        numero: `${data.item.consecutivo.prefijo}${data.item.numero}`
                                    })
                                "
                            ></feather> -->

                            <feather
                                v-if="
                                    permisos.includes(
                                        'devolucion-factura-export-individual'
                                    ) && !isLoading && !((data.item.notaCreditoE.estadoDocumento !==
                                    undefined &&
                                    (data.item.notaCreditoE.estadoDocumento
                                        .codigo === 'DEFAULT' ||
                                        data.item.notaCreditoE
                                            .estadoDocumento.codigo ===
                                        'RECHAZADO')) ||
                                    data.item.notaCreditoE.reenviar)
                                "
                                type="printer"
                                role="button"
                                v-b-popover.hover.top="'Imprimir'"
                                class="ml-2"
                                @click="printDevolucionFactura(data.item.id)"
                            ></feather>
                            <feather
                                v-else
                                type="printer"
                                role="button"
                                class="text-secondary ml-2"
                                v-b-popover.hover.top="'Imprimir'"
                            ></feather>
                            <!-- <span
                                class="mdi mdi-file-pdf-box ml-2"
                                style="font-size: 1.6rem"
                            /> -->
                        </template>
                    </b-table>
                </div>
                <div class="p-3 d-flex align-items-center">
                    <b-form-group
                        label="Número de registros"
                        label-for="per-page-select"
                        label-size="sm"
                        label-class="fw-medium"
                        class="mb-0"
                    >
                        <b-form-select
                            id="per-page-select"
                            v-model="pagination.perPage"
                            :options="pagination.pageOptions"
                            @change="getDevolucionesFacturas(1, $event)"
                            size="sm"
                        ></b-form-select>
                    </b-form-group>
                    <div class="ml-auto">
                        <b-pagination
                            first-number
                            last-number
                            size="sm"
                            v-model="pagination.currentPage"
                            :total-rows="pagination.totalRows"
                            :per-page="pagination.perPage"
                            @input="
                                getDevolucionesFacturas(
                                    $event,
                                    pagination.perPage
                                )
                            "
                            align="fill"
                            class="my-0"
                        ></b-pagination>
                    </div>
                </div>
            </b-card>
            <selectFieldsReport
                :modulo="moduleName"
                :format="selectedFormat"
                :fields="
                    fieldsAvailables[
                        selectedFormat ? selectedFormat.toLowerCase() : 'excel'
                    ]
                "
                @close="selectedFormat = null"
            />
            <emailModal
                :sender="configEmail"
                :modulo="firstToUpperString(moduleName)"
                :fieldsAvailables="fieldsAvailables"
            />
            <emailModal
                :id="'email-modal-single'"
                :sender="configEmail"
                :modulo="firstToUpperString(moduleName)"
                :fieldsAvailables="fieldsAvailables"
                :url="'administracion/devolucion-factura/enviar-mail'"
                :alternativeOpc="'FIND_BY_ID'"
                :extraParamsDatajson="singleEmailParams"
            />
        </b-col>
        <b-col cols="12">
            <div
                class="d-sm-flex mt-4 justify-content-between align-items-center"
            >
                <b-button
                    variant="primary"
                    size="md"
                    class="d-flex align-items-center mt-4 mt-sm-0 mr-4"
                    @click="addRegister"
                    v-b-popover.hover.top="'Presione alt+a o option+a'"
                    :disabled="!permisos.includes('devolucion-factura-crear')"
                >
                    <feather
                        type="plus"
                        size="1rem"
                        class="mr-2 blue-active-text"
                    ></feather>
                    Nueva devolución
                </b-button>
                <b-dropdown
                    id="dropdown-divider"
                    text="Opciones"
                    size="md"
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                    :disabled="
                        !permisos.includes('devolucion-factura-query-export') &&
                        !permisos.includes(
                            'devolucion-factura-query-export-and-email'
                        ) &&
                        !permisos.includes('devolucion-factura-crud-export') &&
                        !permisos.includes('devolucion-factura-crud-import')
                    "
                >
                    <template #button-content>
                        <div
                            class="d-flex justify-content-center align-items-center"
                        >
                            <feather
                                type="more-horizontal"
                                size="1.5rem"
                                class="text-secondary"
                            ></feather>
                        </div>
                    </template>
                    <b-dropdown-item-button
                        v-for="(format, index) in formats"
                        :key="index"
                        @click="verifyFields(format.ext)"
                        :disabled="
                            !permisos.includes(
                                'devolucion-factura-query-export'
                            )
                        "
                    >
                        {{ format.name }}
                    </b-dropdown-item-button>
                    <b-dropdown-item-button
                        @click="$bvModal.show('email-modal')"
                        :disabled="
                            !permisos.includes(
                                'devolucion-factura-query-export-and-email'
                            )
                        "
                        >Enviar informe por Correo</b-dropdown-item-button
                    >
                    <!--
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item-button
                                    @click="getImportFormat(moduleName)"
                                    :disabled="
                                        !permisos.includes('devolucion-factura-crud-export')
                                    "
                                    >Plantilla para importación de
                                    tabla</b-dropdown-item-button
                                >
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item-button
                                    @click="$refs.excelInput.click()"
                                    :disabled="
                                        !permisos.includes('devolucion-factura-crud-import')
                                    "
                                    >Cargar Plantilla para importación de
                                    tabla</b-dropdown-item-button
                                > -->
                </b-dropdown>
            </div>
        </b-col>
    </b-row>
</template>
<script>
import services from '@/boot/axios'
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex'
import selectFieldsReport from '@/components/shared/select-fields-report/select-fields-report'
import emailModal from '@/components/shared/email/email'
import { addListenerCommands, removeListenerCommands, currencyFormat, firstToUpperString, getLabelTercero } from '@/utils/others'
import { validationMixin } from 'vuelidate'
// import { required } from 'vuelidate/lib/validators'
import { compareDates, dateNow } from '@/utils/date'
// import * as XLSX from 'xlsx'
import Jautocomplete from '../../../../components/shared/autocomplete/jautocomplete.vue'
import print from 'print-js'

const formDefault = () =>
    JSON.parse(
        JSON.stringify({
            fecha_inicio: dateNow(-1),
            fecha_final: dateNow(),
            prefijo_id: null
        })
    )

const { API } = services

export default {
    name: 'MainDevolucionesFactura',
    components: { selectFieldsReport, emailModal, Jautocomplete },
    mixins: [validationMixin],
    mounted() {
        this.getLastQueryFilterStored()
        addListenerCommands(this)
        this.getEmpresaEmails()
        this.getAvailableFields()
        this.getConsecutivos()
        this.getDevolucionesFacturas()
    },
    beforeDestroy() {
        removeListenerCommands(this)
    },
    data: () => ({
        isLoading: false,
        fields: [
            { key: 'prefijo', label: 'Prefijo' },
            { key: 'notaCreditoE', label: 'Doc. electrónico' },
            { key: 'numero_factura', label: 'Doc. afectado' },
            { key: 'fecha', label: 'Fecha' },
            { key: 'vencimiento', label: 'Vencimiento' },
            { key: 'cliente', label: 'Cliente' },
            { key: 'cliente_id', label: 'Tercero' },
            { key: 'gran_total', label: 'Total' },
            { key: 'acciones', label: 'Acciones' }
        ],
        form: formDefault(),
        devoluciones_factura: [],
        consecutivos: [],
        pagination: {
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 20, 30, 40, 50, 100]
        },
        singleEmailParams: {},
        search: '',
        fieldsAvailables: {},
        configEmail: null,
        selectedFormat: null,
        moduleName: 'devolucion-factura',
        formats: [
            { id: 1, name: 'Generar Informe Excel', ext: 'EXCEL' },
            { id: 2, name: 'Generar Informe Pdf', ext: 'PDF' }
        ]
    }),
    validations: {
        form: {
            fecha_inicio: {
                compareDates: (d, a) => {
                    if (a.fecha_final) {
                        return compareDates(d, a.fecha_final)
                    }
                    return true
                },
                formatDate: (date) => {
                    if (date) {
                        const regExp =
                            /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
                        const value = regExp.test(date)
                        return value
                    } else {
                        return true
                    }
                }
            },
            fecha_final: {
                compareDates: (d, a) => {
                    if (a.fecha_inicio) {
                        return compareDates(a.fecha_inicio, d)
                    }
                    return true
                },
                formatDate: (date) => {
                    if (date) {
                        const regExp =
                            /^[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/
                        const value = regExp.test(date)
                        return value
                    } else {
                        return true
                    }
                }
            },
            prefijo_id: {}
        }
    },
    methods: {
        showLog(data) {
            console.log(data)
        },
        firstToUpperString,
        getLabelTercero,
        currencyFormat,
        setQueryFilterNoStored(query) {
            const { fullPath } = this.$route

            this.setQueryFilter({ query: { ...query, search: this.search }, path: fullPath })
        },
        getLastQueryFilterStored() {
            // ir a consultar en el store si hay una query de busqueda para esta ruta
            const { fullPath } = this.$route
            const queryFilter = this.getQueryFilter(fullPath)

            // si hay una query se asigna a los valores por defecto
            // si no hay una query queda como está
            if (queryFilter) {
                const { search, path, ...rest } = queryFilter
                path

                this.form = rest
                this.search = search
            }
        },
        getStatusColor(status) {
            if (status === 'RECHAZADO') {
                return 'error'
            } else if (status === 'AUTORIZADO') {
                return 'success'
            } else {
                return 'secondary'
            }
        },
        printDevolucionFactura(devolucion_id) {
            this.isLoading = true
            API.POST({
                url: 'administracion/devolucion-factura/imprimir',
                data: {
                    p_datajson: {
                        id: devolucion_id
                    },
                    p_opc: 'FIND_BY_ID',
                    p_auditoriajson: this.auditoriajson
                }
            })
                .then((response) => {
                    this.isLoading = false
                    const {
                        data: {
                            dato,
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    if (status === 'ok') {
                        // console.log(dato)
                        const base64 = dato.replace(
                            'data:application/pdf;base64,',
                            ''
                        )
                        print({
                            printable: base64,
                            type: 'pdf',
                            base64: true
                        })
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje_exception ||
                                    mensaje ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    this.isLoading = false
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        sendSingleFactura(factura_id) {
            this.singleEmailParams = { id: factura_id }
            this.$bvModal.show('email-modal-single')
        },
        searchData() {
            this.getDevolucionesFacturas(this.search)
        },
        showConfirm({ id, descripcion }) {
            this.$bvModal
                .msgBoxConfirm(
                    `Usted está apunto de eliminar la bodega "${descripcion}", desea continuar con esta acción?`,
                    {
                        title: 'Advertencia!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Continuar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2 d-flex justify-content-between',
                        hideHeaderClose: false,
                        centered: true,
                        headerBgVariant: 'danger',
                        headerClass: 'modal-header'
                    }
                )
                .then((value) => {
                    if (value) {
                        this.deleteCategoria(id)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        deleteCategoria(id) {
            API.POST({
                url: 'administracion/inventario/bodega/crud',
                data: {
                    p_datajson: {
                        id
                    },
                    p_opc: 'DELETE',
                    p_auditoriajson: this.auditoriajson
                }
            })
                .then((response) => {
                    const {
                        data: {
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    if (status === 'ok') {
                        this.getDevolucionesFacturas()
                        this.$bvModal
                            .msgBoxOk(mensaje || 'Eliminado correctamente', {
                                title: 'Exito!',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'success',
                                okTitle: 'Aceptar',
                                cancelTitle: 'Cancelar',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true,
                                headerBgVariant: 'success',
                                headerClass: 'modal-header'
                            })
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        getDevolucionesFacturas(page = 1, limit = this.pagination.perPage) {
            const { fecha_inicio, fecha_final, prefijo_id } = this.form

            this.setQueryFilterNoStored(this.form)

            API.POST({
                url: 'administracion/devolucion-factura/query',
                data: {
                    p_datajson: {
                        page,
                        term: this.search,
                        limit,
                        fecha_inicio,
                        fecha_final,
                        prefijo: prefijo_id === 'Sin prefijo' ? '' : prefijo_id,
                        empresa_id: this.getUltimaEmpresa.id
                    },
                    p_opc: 'FILTER',
                    p_auditoriajson: this.auditoriajson
                }
            })
                .then((response) => {
                    const {
                        data: {
                            dato: { content, totalContent, size, number },
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response

                    // console.log(response.data)

                    if (status === 'ok') {
                        this.devoluciones_factura = content
                        this.pagination = {
                            ...this.pagination,
                            totalRows: totalContent,
                            perPage: size,
                            currentPage: number
                        }
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        verifyFields(ext) {
            this.selectedFormat = ext
            this.$bvModal.show('modal-fields-report')
        },
        getAvailableFields() {
            if (this.permisos.includes('devolucion-factura-query-export')) {
                API.POST({
                    url: 'report/available-fields',
                    data: {
                        p_datajson: {
                            modulo: this.moduleName
                        },
                        p_opc: 'GET_FIELD',
                        p_auditoriajson: this.auditoriajson
                    }
                })
                    .then((response) => {
                        const {
                            data: {
                                dato,
                                status: { status, mensaje, mensaje_exception }
                            }
                        } = response
                        if (status === 'ok') {
                            // console.log(dato)
                            this.fieldsAvailables = dato
                        } else {
                            this.$bvModal
                                .msgBoxOk(
                                    mensaje ||
                                        mensaje_exception ||
                                        'Ha ocurrido un error!',
                                    {
                                        title: 'Error!',
                                        size: 'sm',
                                        buttonSize: 'sm',
                                        okVariant: 'error',
                                        okTitle: 'Aceptar',
                                        cancelTitle: 'Cancelar',
                                        footerClass: 'p-2',
                                        hideHeaderClose: false,
                                        centered: true,
                                        headerBgVariant: 'error',
                                        headerClass: 'modal-header'
                                    }
                                )
                                .then(() => {
                                    // console.log(value);
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        }
                    })
                    .catch((error) => {
                        const { message } = error
                        this.$bvModal
                            .msgBoxOk(message || 'Ha ocurrido un error!', {
                                title: 'Error!',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'error',
                                okTitle: 'Aceptar',
                                cancelTitle: 'Cancelar',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true,
                                headerBgVariant: 'error',
                                headerClass: 'modal-header',
                                noStacking: true
                            })
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    })
            }
        },
        getConsecutivos() {
            if (this.getUltimaEmpresa) {
                API.POST({
                    url: 'administracion/consecutivo/query',
                    data: {
                        p_datajson: {
                            clase_documento_id: 1,
                            empresa_id: this.getUltimaEmpresa.id
                        },
                        p_opc: 'GET_ALL_BY_CLASE_DOCUMENTO',
                        p_auditoriajson: this.auditoriajson
                    }
                })
                    .then((response) => {
                        const {
                            data: {
                                dato,
                                status: { status, mensaje, mensaje_exception }
                            }
                        } = response
                        if (status === 'ok') {
                            // console.log(dato)
                            this.consecutivos = dato.map((c) => {
                                return c.prefijo === ''
                                    ? {
                                          ...c,
                                          prefijo: 'Sin prefijo'
                                      }
                                    : c
                            })
                            // console.log(this.consecutivos)
                        } else {
                            this.$bvModal
                                .msgBoxOk(
                                    mensaje ||
                                        mensaje_exception ||
                                        'Ha ocurrido un error!',
                                    {
                                        title: 'Error!',
                                        size: 'sm',
                                        buttonSize: 'sm',
                                        okVariant: 'error',
                                        okTitle: 'Aceptar',
                                        cancelTitle: 'Cancelar',
                                        footerClass: 'p-2',
                                        hideHeaderClose: false,
                                        centered: true,
                                        headerBgVariant: 'error',
                                        headerClass: 'modal-header'
                                    }
                                )
                                .then(() => {
                                    // console.log(value);
                                })
                                .catch((err) => {
                                    console.log(err)
                                })
                        }
                    })
                    .catch((error) => {
                        const { message } = error
                        this.$bvModal
                            .msgBoxOk(message || 'Ha ocurrido un error!', {
                                title: 'Error!',
                                size: 'sm',
                                buttonSize: 'sm',
                                okVariant: 'error',
                                okTitle: 'Aceptar',
                                cancelTitle: 'Cancelar',
                                footerClass: 'p-2',
                                hideHeaderClose: false,
                                centered: true,
                                headerBgVariant: 'error',
                                headerClass: 'modal-header',
                                noStacking: true
                            })
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    })
            }
        },
        getEmpresaEmails() {
            API.POST({
                url: 'cartero/config-mail/query',
                data: {
                    p_datajson: {
                        empresa_id: this.getUltimaEmpresa.id
                    },
                    p_opc: 'FIND_BY_EMPRESA',
                    p_auditoriajson: this.auditoriajson
                }
            })
                .then((response) => {
                    const {
                        data: {
                            dato,
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    if (status === 'ok') {
                        this.configEmail = dato[0]
                    } else if (dato.length === 0 && status !== 'err') {
                        this.$bvModal
                            .msgBoxConfirm(
                                'Esta empresa no posee configuración de correo para reportes o envío de documentos por email, desea crear una configuración de correo para esta empresa?',
                                {
                                    title: 'Advertencia!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'warning',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'warning',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then((value) => {
                                if (value) {
                                    this.$router
                                        .push({
                                            path: '/home/general/generales/configuracion-email/crear-configuracion-email'
                                        })
                                        .catch((error) => error)
                                }
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        confirmResendNc({ id, numero }) {
            this.$bvModal
                .msgBoxConfirm(
                    `Esta seguro que desea reenviar la devolución ${numero}", a devolución electrónica?`,
                    {
                        title: 'Advertencia!',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: 'Continuar',
                        cancelTitle: 'Cancelar',
                        footerClass: 'p-2 d-flex justify-content-between',
                        hideHeaderClose: false,
                        centered: true,
                        headerBgVariant: 'danger',
                        headerClass: 'modal-header'
                    }
                )
                .then((value) => {
                    if (value) {
                        this.resendNc(id)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        resendNc(id) {
            this.isLoading = true
            API.POST({
                url: 'administracion/devolucion-factura/reenviar-nc',
                data: {
                    p_datajson: {
                        id
                    },
                    p_opc: 'FIND_BY_ID',
                    p_auditoriajson: this.auditoriajson
                }
            })
                .then((response) => {
                    this.isLoading = false
                    const {
                        data: {
                            // dato,
                            status: { status, mensaje, mensaje_exception }
                        }
                    } = response
                    console.log(response)
                    if (status === 'ok') {
                        this.getDevolucionesFacturas(
                            this.pagination.currentPage,
                            this.pagination.perPage
                        )

                        this.$notify({
                            group: 'general',
                            title: 'Reenvio exitoso',
                            text: 'La devolución electrónica se ha rrenviado exitosamente',
                            ignoreDuplicates: true,
                            duration: 5000,
                            type: 'success'
                        })
                    } else {
                        this.$bvModal
                            .msgBoxOk(
                                mensaje ||
                                    mensaje_exception ||
                                    'Ha ocurrido un error!',
                                {
                                    title: 'Error!',
                                    size: 'sm',
                                    buttonSize: 'sm',
                                    okVariant: 'error',
                                    okTitle: 'Aceptar',
                                    cancelTitle: 'Cancelar',
                                    footerClass: 'p-2',
                                    hideHeaderClose: false,
                                    centered: true,
                                    headerBgVariant: 'error',
                                    headerClass: 'modal-header'
                                }
                            )
                            .then(() => {
                                // console.log(value);
                            })
                            .catch((err) => {
                                console.log(err)
                            })
                    }
                })
                .catch((error) => {
                    this.isLoading = false
                    const { message } = error
                    this.$bvModal
                        .msgBoxOk(message || 'Ha ocurrido un error!', {
                            title: 'Error!',
                            size: 'sm',
                            buttonSize: 'sm',
                            okVariant: 'error',
                            okTitle: 'Aceptar',
                            cancelTitle: 'Cancelar',
                            footerClass: 'p-2',
                            hideHeaderClose: false,
                            centered: true,
                            headerBgVariant: 'error',
                            headerClass: 'modal-header'
                        })
                        .then(() => {
                            // console.log(value);
                        })
                        .catch((err) => {
                            console.log(err)
                        })
                })
        },
        rowClass(item, type) {
            if (!item || type !== 'row') return
            if (item.status === 'active') return 'active'
        },
        addRegister() {
            this.$router.push(
                '/home/administrativo/documentos/devolucion-factura/crear-devolucion-factura'
            )
        },
        validateState(key) {
            const { $dirty, $error } = this.$v.form[key]
            return $dirty ? !$error : null
        },
        ...mapActions(['getImportFormat']),
        ...mapMutations(['setQueryFilter'])
    },
    computed: {
        keymap() {
            if (
                navigator.platform.toLowerCase().includes('mac') ||
                navigator.platform.toLowerCase().includes('macintosh')
            ) {
                return {
                    'alt+a': this.addRegister,
                    'command+b': this.getDevolucionesFacturas
                }
            } else if (
                navigator.platform.toLowerCase().includes('win') ||
                navigator.platform.toLowerCase().includes('windows')
            ) {
                return {
                    'alt+a': this.addRegister,
                    'ctrl+b': this.getDevolucionesFacturas
                }
            } else {
                return {}
            }
        },
        auditoriajson() {
            const json = { ...this.getAuditoriaJson, modulo_id: 41 }
            return json
        },
        permisos() {
            return this.getPermisos.permisos_authorities
        },
        ...mapGetters('usuario', [
            'getUserData',
            'getAuditoriaJson',
            'getPermisos'
        ]),
        ...mapGetters(['getQueryFilter']),
        ...mapGetters('empresas', ['getUltimaEmpresa']),
        ...mapState(['Theme'])
    }
}
</script>

<style></style>
